'use strict';

// ─── Debug helper ─────────────────────────────────────────────────────────────
// Descomentar y llamar window.__billingDebug() desde la consola para inspeccionar el formulario.
// window.__billingDebug = function () {
//   const ids = [
//     'document_type', 'document_number', 'first_name', 'last_name',
//     'company_name', 'billing_email', 'billing_phone', 'billing_address',
//     'custom_provinces_ship', 'custom_cities_ship', 'billing_agree',
//     'billing-checkout-btn',
//   ];
//   const state = {};
//   ids.forEach(function (id) {
//     const el = document.getElementById(id);
//     if (!el) { state[id] = '⚠️ NO ENCONTRADO EN DOM'; return; }
//     if (el.type === 'checkbox') {
//       state[id] = { checked: el.checked };
//     } else if (el.tagName === 'SELECT') {
//       state[id] = { value: el.value, text: el.selectedOptions[0]?.textContent.trim() };
//     } else if (el.tagName === 'BUTTON') {
//       state[id] = { disabled: el.disabled, busy: el.dataset.busy };
//     } else {
//       state[id] = { value: el.value };
//     }
//   });
//   console.group('%c[BillingForm] Estado actual del formulario', 'color:#6366f1;font-weight:bold');
//   console.table(state);
//   console.groupEnd();
//   return state;
// };

// ─── 1. Guardar atributos en el carrito ───────────────────────────────────────

/**
 * Persiste atributos en cart.attributes de Shopify y espera confirmación.
 * Los atributos quedan vinculados al pedido como note_attributes y aparecen
 * en Admin → Pedidos → "Información adicional".
 *
 * @param {Record<string, string>} attributes
 * @returns {Promise<object>} Objeto cart confirmado por Shopify
 */
async function billingUpdateCartAttributes(attributes) {
  // console.group('%c[BillingForm] billingUpdateCartAttributes', 'color:#0ea5e9;font-weight:bold');
  // console.log('Payload →', attributes);

  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes }),
  });

  // console.log('HTTP status:', response.status, response.ok ? '✅ OK' : '❌ ERROR');

  if (!response.ok) {
    // console.groupEnd();
    throw new Error('[BillingForm] Error HTTP ' + response.status + ' al guardar atributos');
  }

  const cart = await response.json();
  // console.log('cart.attributes confirmados por Shopify:', cart.attributes);
  // console.groupEnd();
  return cart;
}

// ─── 2. Validar el formulario de facturación ──────────────────────────────────

/**
 * Valida los campos requeridos del formulario según el tipo de documento.
 *
 * @returns {{ valid: boolean, message?: string }}
 */
function billingValidateForm() {
  const get = (id) => document.getElementById(id);

  // console.group('%c[BillingForm] billingValidateForm', 'color:#f59e0b;font-weight:bold');

  const checks = {
    document_type:         get('document_type')?.value || '',
    document_number:       get('document_number')?.value.trim() || '',
    billing_email:         get('billing_email')?.value.trim() || '',
    billing_phone:         get('billing_phone')?.value.trim() || '',
    custom_provinces_ship: get('custom_provinces_ship')?.value || '',
    custom_cities_ship:    get('custom_cities_ship')?.value || '',
    billing_address:       get('billing_address')?.value.trim() || '',
    first_name:            get('first_name')?.value.trim() || '',
    last_name:             get('last_name')?.value.trim() || '',
    company_name:          get('company_name')?.value.trim() || '',
  };
  // console.log('Valores leídos:', checks);

  const fail = function (message) {
    // console.warn('❌ Falla:', message);
    // console.groupEnd();
    return { valid: false, message: message };
  };

  const docType = checks.document_type;
  if (!docType)                      return fail('Seleccione un tipo de documento.');
  if (!checks.document_number)       return fail('Ingrese el número de documento.');
  if (!checks.billing_email)         return fail('Ingrese un correo electrónico.');
  if (!checks.billing_phone)         return fail('Ingrese un número de teléfono.');
  if (!checks.custom_provinces_ship) return fail('Seleccione un departamento.');
  if (!checks.custom_cities_ship)    return fail('Seleccione un municipio.');
  if (!checks.billing_address)       return fail('Ingrese la dirección de facturación.');

  if (docType === 'cc') {
    if (!checks.first_name) return fail('Ingrese el nombre del titular.');
    if (!checks.last_name)  return fail('Ingrese el apellido del titular.');
  } else if (docType === 'nit') {
    if (!checks.company_name) return fail('Ingrese la razón social.');
  } else {
    return fail('Tipo de documento no reconocido: ' + docType);
  }

  // console.log('✅ Validación OK — tipo:', docType);
  // console.groupEnd();
  return { valid: true };
}

// console.log('%c[BillingForm] billing-form-utils.js cargado ✅', 'color:#6366f1;font-weight:bold');
// console.log('  → Llama window.__billingDebug() para inspeccionar el formulario');
